export default __webpack_public_path__ + "static/B41-13adaa0fcfa9a4f850c2f0037c64ccc1.png";